/* Shoplift A/B test — "Collection Card v5 - Per-Collection Capacity"
 * Test type: API (JavaScript API), visitor assignment: MANUAL.
 *
 * Both arms are already in the DOM: every in-scope product rendered a v2
 * card and a v3 card, and CSS is showing the v2 one. This script decides
 * whether to flip that, and it is the ONLY thing that adds the visitor to
 * the test.
 *
 * Why manual assignment: we apply the variant ourselves. If Shoplift
 * bucketed visitors automatically and this script then failed, a visitor
 * would be counted as variant while looking at the control card, which is
 * worse than not testing them at all. With manual assignment, a visitor is
 * only ever added at the moment we are about to change what they see.
 *
 * Fail-safe: if window.shoplift never appears, the call throws, or the
 * timeout is hit, nothing happens - the control card stays visible and no
 * assignment is made.
 *
 * QA, while the test is still a draft:
 *   ?slVariant=<variant hypothesis id>   force B
 *   ?slVariant=<control hypothesis id>   force A
 */
(function () {
    var WAIT_MS = 2000;
    var POLL_MS = 50;

    var grid = document.querySelector('.collectionV2Grid.slTest');
    if (!grid) return;

    var hypothesisId = grid.getAttribute('data-sl-hypothesis');
    if (!hypothesisId) return;

    function applyVariant() {
        grid.classList.add('slVariant');

        /* Read this BEFORE the class is removed below. */
        var hasCompareLink = !!document.querySelector('.slVariantOnly .collectionV2CompareLink');

        /* Reveal by REMOVING the hiding class, not by restoring a display
           value from a second class.
         *
         * The hidden parts are a block-level <section> (the compare table)
         * and an inline wrapper (the compare link), so any one display
         * value a reveal rule picked would be wrong for the other. It was:
         * inline-flex turned the compare section into a flex row and laid
         * its intro and its table out side by side. Removing the class
         * returns each element to whatever display its own CSS gives it. */
        var hidden = document.querySelectorAll('.slVariantOnly');
        for (var i = 0; i < hidden.length; i++) {
            hidden[i].classList.remove('slVariantOnly');
        }

        var sorting = document.querySelector('.collectionV2TopSorting');
        if (sorting) {
            /* The v3 results row puts the count at the left and the sort at
               the right, on every page in the test - the handoff does this
               on Shop All too, where there is no compare entry. Both classes
               are withheld from control, so the control row keeps exactly
               the layout it has today. */
            sorting.classList.add('isLeftAligned');

            /* Only about an entry being present: spacing it off the count,
               and letting the row wrap on mobile. */
            if (hasCompareLink) sorting.classList.add('hasCompareEntry');
        }
    }

    /* QA override. Checked before Shoplift is consulted so a forced arm
       works while the test is a draft and no assignment exists yet. */
    var forced = new URLSearchParams(window.location.search).get('slVariant');
    if (forced) {
        if (forced === hypothesisId) applyVariant();
        return;
    }

    function whenShopliftReady() {
        return new Promise(function (resolve, reject) {
            if (window.shoplift) return resolve(window.shoplift);
            var waited = 0;
            var timer = setInterval(function () {
                if (window.shoplift) {
                    clearInterval(timer);
                    resolve(window.shoplift);
                } else if ((waited += POLL_MS) >= WAIT_MS) {
                    clearInterval(timer);
                    reject(new Error('shoplift did not initialise'));
                }
            }, POLL_MS);
        });
    }

    /* ------------------------------------------------------------------
     * Chord CDP
     *
     * Shoplift's assignment lives in Shoplift. It never reaches the CDP, so
     * nothing in Chord can be cut by arm - not by page, not by device, not
     * by day. One track event at the moment of assignment turns every one
     * of those from a dead end into a query.
     *
     * Fired for BOTH arms. A control event is not optional: without one
     * there is a variant population and nobody to compare it against.
     *
     * The arm is read back out of shoplift.getVisitorData() rather than
     * inferred from the boolean, so what lands in the CDP is Shoplift's own
     * record - its test id, hypothesis id and assignedTo - and the two
     * systems can be joined on the visitor id afterwards.
     *
     * The QA override above returns before any of this, so forced page
     * loads stay out of the CDP the same way they stay out of the test.
     * ------------------------------------------------------------------ */
    var CHORD_WAIT_MS = 8000;

    function whenChordReady() {
        return new Promise(function (resolve, reject) {
            if (window.chord && typeof window.chord.track === 'function') {
                return resolve(window.chord);
            }
            var waited = 0;
            var timer = setInterval(function () {
                if (window.chord && typeof window.chord.track === 'function') {
                    clearInterval(timer);
                    resolve(window.chord);
                } else if ((waited += POLL_MS) >= CHORD_WAIT_MS) {
                    clearInterval(timer);
                    reject(new Error('chord did not initialise'));
                }
            }, POLL_MS);
        });
    }

    /* Chord loads as a module at the end of <body> and Shoplift loads in the
       <head>, so this waits longer than the Shoplift poll does. */
    function track(name, props) {
        whenChordReady()
            .then(function (chord) {
                return chord.track(name, props);
            })
            .catch(function () {
                /* Same reasoning as the assignment catch below. */
            });
    }

    function collectionHandle() {
        var parts = window.location.pathname.split('/collections/');
        return parts.length > 1 ? parts[1].split('/')[0].split('?')[0] : '';
    }

    /* Shoplift records the control hypothesis against the visitor, not the
       variant one, so a control assignment cannot be found by the id this
       grid carries. Both ids are on the grid for that reason. */
    function findAssignment(data) {
        var ids = [hypothesisId, grid.getAttribute('data-sl-control-hypothesis')];
        var tests = (data && data.visitorTests) || [];
        for (var i = 0; i < tests.length; i++) {
            if (ids.indexOf(tests[i].hypothesisId) !== -1) return tests[i];
        }
        return null;
    }

    function stored(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    /* getVisitorData().visitor is null on a visitor's FIRST page view - the
       record has not been persisted yet, and it does not fill in later on
       that page either (measured: still null 43s in). It is populated on
       every subsequent view. Since our event fires on the first view, the
       API alone would report null for exactly the visitors who most need
       identifying, so these two read what Shoplift has already written to
       storage by then. */
    function essential() {
        var raw = stored('Shoplift_Essential');
        if (!raw) return null;
        try {
            return JSON.parse(raw);
        } catch (e) {
            return null;
        }
    }

    function reportAssignment(isVariant) {
        var arm = isVariant ? 'variant' : 'control';
        var handle = collectionHandle();

        function send(record, visitor) {
            /* An exposure event needs an exposure. Shoplift answers "is this
               visitor in the variant?" with a plain false both when they are
               in the control arm and when the test is not running at all, so
               the boolean cannot tell those apart - and once a test is
               stopped, reporting on it would log a control event on every
               collection page view for as long as the code is live, growing
               that arm forever against a test that has ended.

               The assignment record is what distinguishes them: Shoplift
               writes one only for a visitor it actually enrolled, and it is
               present from the first page view. No record and no variant
               means nobody was enrolled, so nothing is reported. */
            if (!record && !isVariant) return;

            var ess = essential();
            var initial = (ess && ess.initialState) || null;

            track('Experiment Viewed', {
                experiment_id: (record && record.testId) || null,
                experiment_name: (record && record.testTitle) || 'Collection Card v5 - Per-Collection Capacity',
                variant_id: (record && record.hypothesisId) || hypothesisId,
                variant: (record && record.assignedTo) || arm,
                collection_handle: handle,

                /* The id that appears in Shoplift's orders export. Null on a
                   first page view; present from the second on, which is
                   enough for the join that matters, because a visitor who
                   reaches an order has more than one page view. */
                shoplift_visitor_id: (visitor && visitor.id) || null,

                /* Always available, from the first view. A per-browser id,
                   NOT the same value as the visitor id above and a different
                   UUID version - do not assume the two join without checking
                   with Shoplift first. It is here so first-view events are
                   not anonymous. */
                shoplift_client_id: stored('Shoplift_ClientId'),

                /* Shoplift's own device classification, so device cuts agree
                   across the two systems instead of being two instruments. */
                shoplift_device: (visitor && visitor.device) || (initial && initial.device) || null,

                first_view: !(visitor && visitor.id)
            });
        }

        /* getVisitorData is a read. If it is missing or throws, the boolean
           we already have is enough to report the arm - losing the join key
           is better than losing the event. */
        try {
            var data = window.shoplift.getVisitorData();
            if (data && typeof data.then === 'function') {
                data.then(function (d) {
                    send(findAssignment(d), d && d.visitor);
                }).catch(function () {
                    send(null, null);
                });
                return;
            }
            send(findAssignment(data), data && data.visitor);
        } catch (e) {
            send(null, null);
        }
    }

    whenShopliftReady()
        .then(function (shoplift) {
            return shoplift.isHypothesisActive(hypothesisId);
        })
        .then(function (isVariant) {
            if (isVariant) applyVariant();
            reportAssignment(isVariant);
        })
        .catch(function (err) {
            /* Control experience, visitor not enrolled. Deliberately silent
               in the console: an error here would fire on every page view
               for every visitor whose network hiccuped.

               It is NOT silent in the CDP. This is the population that made
               Shoplift's bucketed count fall short of the collection-page
               visitor count, and until now it was invisible from both
               sides - Shoplift cannot see a visitor it never enrolled, and
               Chord could not tell one apart from an enrolled one. With
               this event the gap can be sized, and checked for a device or
               connection skew that would unbalance the arms. */
            track('Experiment Not Assigned', {
                experiment_name: 'Collection Card v5 - Per-Collection Capacity',
                variant_id: hypothesisId,
                collection_handle: collectionHandle(),
                reason: (err && err.message) || 'unknown'
            });
        });
})();
